import React from 'react';
import { 
  FaStore, 
  FaHome, 
  FaWhatsapp, 
  FaHeadset, 
  FaMapMarkerAlt,
  FaStar,
  FaArrowRight,
  FaClock,
  FaPhone,
  FaEnvelope,
  FaFire
} from 'react-icons/fa';

const StoresServices = () => {
  const services = [
    {
      id: 1,
      title: 'Visit Store',
      description: 'Find nearest store & try frames',
      fullDescription: 'Visit any of our 1000+ stores across BRframes, opposite west gate of police station, Bhabua Bihar 821101',
      icon: <FaStore className="text-2xl" />,
      image: 'home-harmony-desktop-store-and-services-visit-store',
      stats: '1000+ Stores'
    },
    {
      id: 2,
      title: 'Home Eye Test',
      description: 'Free eye checkup at home',
      fullDescription: 'Book a free professional eye test at your doorstep',
      icon: <FaHome className="text-2xl" />,
      image: 'home-harmony-desktop-store-and-services-home-eye-test',
      stats: 'Free Service'
    },
    {
      id: 3,
      title: 'Order on WhatsApp',
      description: 'Order via chat',
      fullDescription: 'Quick ordering through WhatsApp chat support',
      icon: <FaWhatsapp className="text-2xl" />,
      image: 'home-harmony-desktop-store-and-services-order-on-wa',
      stats: '24/7 Support'
    },
    {
      id: 4,
      title: 'Connect Experts',
      description: 'Talk to specialists',
      fullDescription: 'Get expert advice from eyewear specialists',
      icon: <FaHeadset className="text-2xl" />,
      image: 'home-harmony-desktop-store-and-services-connect-experts',
      stats: 'Live Chat'
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-b from-white via-orange-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-orange-500 text-white px-5 py-2 rounded-full text-sm font-semibold mb-4 shadow-lg">
            <FaStar className="text-white text-sm animate-spin-slow" />
            <span>OUR SERVICES</span>
            <FaStar className="text-white text-sm animate-spin-slow" />
          </div>
          
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 mb-3">
            Nearby Stores & <span className="text-orange-500">Services</span>
          </h2>
          
          <div className="flex justify-center items-center gap-2 mb-4">
            <div className="w-12 h-0.5 bg-gradient-to-r from-transparent via-orange-500 to-transparent"></div>
            <div className="w-2 h-2 bg-orange-500 rounded-full animate-pulse"></div>
            <div className="w-12 h-0.5 bg-gradient-to-r from-transparent via-orange-500 to-transparent"></div>
          </div>
          
          <p className="text-gray-500 text-sm max-w-2xl mx-auto">
            Experience the best of BRframes with our range of customer services
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service) => (
            <a
              key={service.id}
              href="#"
              className="group relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden transform hover:-translate-y-2 border border-gray-100 hover:border-orange-500"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-orange-500 to-orange-600 opacity-0 group-hover:opacity-5 transition-opacity duration-500"></div>
              <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-orange-500 to-orange-600 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
              <div className="relative p-6">
                <div className="relative mb-4">
                  <div className="absolute inset-0 bg-orange-100 rounded-2xl blur-lg opacity-50 group-hover:opacity-100 transition-opacity duration-500"></div>
                  <div className="relative w-16 h-16 bg-orange-50 rounded-2xl flex items-center justify-center group-hover:scale-110 group-hover:rotate-6 transition-all duration-300 shadow-md border border-orange-200">
                    <div className="text-orange-500 text-2xl">
                      {service.icon}
                    </div>
                  </div>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-orange-500 transition-colors duration-300">
                  {service.title}
                </h3>
                <p className="text-sm text-gray-500 mb-2">
                  {service.description}
                </p>
                <p className="text-xs text-gray-400 mb-4">
                  {service.fullDescription}
                </p>
                <div className="flex items-center gap-2 mb-4">
                  <span className="text-[10px] font-semibold px-2 py-1 bg-orange-100 text-orange-600 rounded-full">
                    {service.stats}
                  </span>
                  <span className="text-[10px] text-gray-400">
                    {service.image}
                  </span>
                </div>
                <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                  <span className="text-xs font-medium text-gray-500 group-hover:text-orange-500 transition-colors duration-300">
                    Know More
                  </span>
                  <div className="w-8 h-8 rounded-full bg-gradient-to-r from-orange-500 to-orange-600 flex items-center justify-center text-white transform group-hover:scale-110 group-hover:rotate-12 transition-all duration-300 shadow-md">
                    <FaArrowRight className="text-xs" />
                  </div>
                </div>
              </div>

              <div className="absolute bottom-0 left-5 right-5 h-[2px] bg-gradient-to-r from-transparent via-orange-500 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </a>
          ))}
        </div>

        <div className="mt-12 lg:mt-16">
          <div className="relative bg-gradient-to-r from-orange-500 to-orange-600 rounded-3xl overflow-hidden shadow-2xl">
            <div className="absolute inset-0 opacity-10">
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,white,transparent)]"></div>
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_50%,white,transparent)]"></div>
            </div>
            <div className="relative px-6 py-8 lg:px-10 lg:py-10 flex flex-col lg:flex-row items-center justify-between gap-6">
              <div className="text-center lg:text-left">
                <div className="inline-flex items-center gap-2 bg-black/20 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm font-semibold mb-4 border border-white/20">
                  <FaMapMarkerAlt className="text-white animate-pulse" />
                  <span>STORE LOCATOR</span>
                </div>
                <h3 className="text-2xl lg:text-3xl font-bold text-white mb-2">
                  Find a Store Near You
                </h3>
                <p className="text-white/80 text-sm max-w-md">
                  Visit our stores for personalized fitting and expert advice
                </p>
              </div>
              <div className="w-full lg:w-auto">
                <div className="flex flex-col sm:flex-row gap-3">
                  <div className="relative">
                    <input
                      type="text"
                      placeholder="Enter city or pincode"
                      className="w-full sm:w-64 px-5 py-3 pr-10 rounded-full text-sm focus:outline-none focus:ring-2 focus:ring-black/20 bg-white/95 backdrop-blur-sm border border-white/50"
                    />
                    <FaMapMarkerAlt className="absolute right-4 top-3.5 text-orange-500 text-sm" />
                  </div>
                  <button className="bg-black text-white px-6 py-3 rounded-full text-sm font-semibold hover:bg-gray-800 transition-all duration-300 shadow-lg hover:shadow-xl flex items-center justify-center gap-2 group transform hover:-translate-y-0.5">
                    <span>Search</span>
                    <FaArrowRight className="text-xs group-hover:translate-x-1 transition-transform" />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6">
            <div className="bg-white rounded-xl p-4 text-center shadow-sm hover:shadow-md transition-all border border-gray-100 hover:border-orange-500 group">
              <div className="text-2xl font-bold text-orange-500 mb-1">1000+</div>
              <p className="text-xs text-gray-600">Stores Nationwide</p>
            </div>
            <div className="bg-white rounded-xl p-4 text-center shadow-sm hover:shadow-md transition-all border border-gray-100 hover:border-orange-500 group">
              <div className="text-2xl font-bold text-orange-500 mb-1">24/7</div>
              <p className="text-xs text-gray-600">Customer Support</p>
            </div>
            <div className="bg-white rounded-xl p-4 text-center shadow-sm hover:shadow-md transition-all border border-gray-100 hover:border-orange-500 group">
              <div className="text-2xl font-bold text-orange-500 mb-1">Free</div>
              <p className="text-xs text-gray-600">Home Eye Test</p>
            </div>
            <div className="bg-white rounded-xl p-4 text-center shadow-sm hover:shadow-md transition-all border border-gray-100 hover:border-orange-500 group">
              <div className="text-2xl font-bold text-orange-500 mb-1">30 Min</div>
              <p className="text-xs text-gray-600">Store Visit</p>
            </div>
          </div>
        </div>
        <div className="flex flex-wrap justify-center items-center gap-4 mt-10">
          <a href="#" className="flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-sm hover:shadow-md transition-all border border-gray-200 hover:border-orange-500 group">
            <FaPhone className="text-orange-500 text-sm group-hover:scale-110 transition-transform" />
            <span className="text-xs text-gray-700">9709799555</span>
          </a>
          <a href="#" className="flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-sm hover:shadow-md transition-all border border-gray-200 hover:border-orange-500 group">
            <FaEnvelope className="text-orange-500 text-sm group-hover:scale-110 transition-transform" />
            <span className="text-xs text-gray-700">info@brframes.com</span>
          </a>
          <a href="#" className="flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-sm hover:shadow-md transition-all border border-gray-200 hover:border-orange-500 group">
            <FaClock className="text-orange-500 text-sm group-hover:scale-110 transition-transform" />
            <span className="text-xs text-gray-700">10 AM - 8 PM</span>
          </a>
        </div>

        <div className="flex justify-center items-center gap-3 mt-8">
          <div className="w-2 h-2 bg-orange-300 rounded-full animate-pulse"></div>
          <div className="w-2 h-2 bg-orange-400 rounded-full animate-pulse" style={{ animationDelay: '0.2s' }}></div>
          <div className="w-2 h-2 bg-orange-500 rounded-full animate-pulse" style={{ animationDelay: '0.4s' }}></div>
          <div className="w-2 h-2 bg-orange-400 rounded-full animate-pulse" style={{ animationDelay: '0.6s' }}></div>
          <div className="w-2 h-2 bg-orange-300 rounded-full animate-pulse" style={{ animationDelay: '0.8s' }}></div>
        </div>
      </div>

      <style jsx>{`
        @keyframes spin-slow {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        .animate-spin-slow {
          animation: spin-slow 3s linear infinite;
        }
      `}</style>
    </section>
  );
};

export default StoresServices;